/** Check if storage is persisted already.
  @returns {Promise<boolean>} Promise resolved with true if current origin is
  using persistent storage, false if not, and undefined if the API is not
  present.
*/
const isStoragePersisted = async () => {
  return await navigator.storage && navigator.storage.persisted ?
    navigator.storage.persisted() :
    undefined;
}

/** Tries to convert to persisted storage.
  @returns {Promise<boolean>} Promise resolved with true if successfully
  persisted the storage, false if not, and undefined if the API is not present.
*/

const persist = async () => {
  return await navigator.storage && navigator.storage.persist ?
    navigator.storage.persist() :
    undefined;
}

export const tryPersistWithoutPromtingUser = async () => {
  isStoragePersisted().then(async isPersisted => {
    if (isPersisted) {
      console.info(":) Storage is successfully persisted.");
    } else {
      console.info(":( Storage is not persisted.");
      console.info("Trying to persist..:");
      if (await persist()) {
        console.info(":) We successfully turned the storage to be persisted.");
      } else {
        console.info(":( Failed to make storage persisted");
      }
    }
  })

}

/** Tries to persist storage without ever prompting user.
  @returns {Promise<string>}
    "never" In case persisting is not ever possible. Caller don't bother
      asking user for permission.
    "prompt" In case persisting would be possible if prompting user first.
    "persisted" In case this call successfully silently persisted the storage,
      or if it was already persisted.
*/
const tryPersistWithoutPromtingUserX = async () => {
  if (!navigator.storage || !navigator.storage.persisted) {
    return "never";
  }
  let persisted = await navigator.storage.persisted();
  if (persisted) {
    return "persisted";
  }
  if (!navigator.permissions || !navigator.permissions.query) {
    return "prompt"; // It MAY be successful to prompt. Don't know.
  }
  const permission = await navigator.permissions.query({
    name: "persistent-storage"
  });
  if (permission.state === "granted") {
    persisted = await navigator.storage.persist();
    if (persisted) {
      return "persisted";
    } else {
      throw new Error("Failed to persist");
    }
  }
  if (permission.state === "prompt") {
    return "prompt";
  }
  return "never";
}

export const initStoragePersistence = async () => {
  const persist = await tryPersistWithoutPromtingUserX();
  switch (persist) {
    case "never":
      console.info("Not possible to persist storage");
      break;
    case "persisted":
      console.info("Successfully persisted storage silently");
      break;
    case "prompt":
      console.info("Not persisted, but we may prompt user when we want to.");
      break;
  }
}